export const isDev = (): boolean => import.meta.env.MODE === 'development';
export const isProd = (): boolean => import.meta.env.MODE === 'production';

// VITE_BUILD_TYPE can be one of
// ['JAKHUB', 'JAKHUB-CN', 'MENUS']
// These are set in the build script
// URL management is different in (JAKHUB vs JAKHUB-CN) vs Jakhub's MENUS
export const isJakhub = (): boolean =>
    import.meta.env?.VITE_BUILD_TYPE?.substring(0, 6) === 'JAKHUB';
export const isJakhubForChina = (): boolean => import.meta.env.VITE_BUILD_TYPE === 'JAKHUB-CN';

export const myEnv = (): any => {
    console.log('import.meta.env :  ', import.meta.env);
    const envKeys = Object.keys(import.meta.env);
    console.log('envKeys :  ', envKeys);

    return import.meta.env;
};
